<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productLocation.productLocation') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: 'Home', href: '/' },
          { text: $t('productLocation.productLocation'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'product-location-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 300px;"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'location.location_name'
        }"
      >
        <template v-slot="{ record }">
          <td>
            {{ record.branch.branch_name_en }}
          </td>
          <td class="text-center">
            {{ record.product ? record.product.barcode : '' }}
          </td>
          <td>{{ record.product ? record.product.product_name_kh : '' }}</td>
          <td>{{ record.product ? record.product.product_name_en : '' }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="'Delete'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'product-location',
  data() {
    return {
      loading: false,
      columns: [
        { name: this.$t('productLocation.branch'), style: 'width: 15%' },
        {
          name: this.$t('productLocation.barcode'),
          style: 'text-align:center; width: 10%'
        },
        { name: this.$t('productLocation.nameKH') },
        { name: this.$t('productLocation.nameEN') },
        { name: this.$t('actions'), style: 'text-align:center;width: 2%' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('productLocation', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.productLocation.search
      },
      set(newValue) {
        this.$store.commit('productLocation/SET_SEARCH', newValue)
        this.$store.commit('productLocation/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('productLocation/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('productLocation/destroy', record.product_location_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'product-location-create') {
      this.$store.commit('productLocation/RESET_STATE')
      this.$store.commit('productLocation/SET_LOCATIONS', [])
      this.$store.commit('productLocation/SET_PRODUCTS', [])
    }
    next()
  }
}
</script>
